import { useTheme } from '@emotion/react';
import { InputAdornment, TextField } from '@mui/material'
import { SearchIcon } from 'lucide-react'
import React from 'react'

const SearchInput = ({ label, value, onChange }) => {

    const theme = useTheme();
    const {


        text: { secondary: textSecondary },

    } = theme.palette;
    return (
        <TextField
            placeholder={label}
            size="small"
            value={value}
            onChange={onChange}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon sx={{ color: textSecondary }} />
                    </InputAdornment>
                )
            }}
            sx={{
                width: { xs: '100%', sm: 400 },
            }}
        />
    )
}

export default SearchInput